import { render, staticRenderFns } from "./RedirectAction.vue?vue&type=template&id=08a5a07e&"
import script from "./RedirectAction.vue?vue&type=script&lang=js&"
export * from "./RedirectAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports